import { useSelector } from 'react-redux'
import { ProfileStyle } from './styled'

import ticketIcon from '../../assets/ticket.png'
import { externalRoutes } from '../../routes'
const ProfileContent = () => {
  const { currentUser } = useSelector((state: any) => state.auth)

  return (
    <ProfileStyle>
      <div className="row">
        <div className="col-md-7 mb-3">
          {currentUser ? (
            <div className="shadow border bg-white rounded p-4 h-100">
              <div className="d-flex flex-column h-100">
                <div className="flex-grow-1">
                  <div className="d-flex justify-content-between">
                    <p className="text-muted text-1xl">
                      {currentUser.memberType}
                    </p>
                  </div>
                  <div className="mt-1 text-2xl">
                    <p className="m-0 mb-2 fw-bold text-uppercase">
                      {currentUser.fullName}
                    </p>
                    <p className="m-0 mb-1">{currentUser.phone}</p>
                    <p className="m-0 mb-1">{currentUser.email}</p>
                    <p className="m-0 mb-1">{currentUser.companyName}</p>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="placeholder placeholder-wave w-100 bg-light"></div>
          )}
        </div>
        <div className="col-md-5 mb-3">
          {currentUser ? (
            <div className="shadow border bg-white rounded p-4">
              <div className="d-flex justify-content-between">
                <h4>{currentUser.memberType}</h4>
                <img src={ticketIcon} alt="ticket" height={30} width={40} />
              </div>
              <p className="text-muted mb-0 mt-4">Pass Activated</p>
              <div style={{ height: 100 }}></div>
              {currentUser.passType === 'dp' && (
                <a
                  rel="noreferrer"
                  href={externalRoutes.dashboard}
                  target="_blank"
                  className="btn btn-outline-danger d-block mx-auto px-4 py-2 w-100 mt-4"
                >
                  Upgrade to All Access Pass
                </a>
              )}
              <a
                rel="noreferrer"
                href={externalRoutes.passPdf}
                target="_blank"
                className="btn btn-success d-block mx-auto px-4 py-2 w-100 mt-2"
              >
                DOWNLOAD ACCESS PASS
              </a>
            </div>
          ) : (
            <div className="placeholder placeholder-wave w-100 bg-light"></div>
          )}
        </div>
      </div>
    </ProfileStyle>
  )
}

export default ProfileContent
